import React from 'react';
import renderIf from 'render-if';
import classNames from 'classnames';
import QuestionIconPopover from 'components/common/question_icon_popover';

function SectionedList(props) {
  const sections = props.options.map(section => {
    const { title, value, children, key } = section;

    return (
      <div className='sectioned-list__section' key={value || key}>
        {renderIf(title)(
          <div className='sectioned-list__title'>
            <b>{title}</b>
          </div>
        )}
        {children.map(item => {
          return (
            <div
              className={classNames(
                'sectioned-list__item selectable-nav-item',
                {
                  'selectable-nav-item--selected':
                    item.value === props.selected,
                }
              )}
              key={item.value}
              onClick={() => props.onClick(item)}
              onDoubleClick={() => {
                if (props.onDoubleClick) props.onDoubleClick(item);
              }}
            >
              <span className='sectioned-list__item__title'>
                {item.text}
                {renderIf(item.new)(() => (
                  <span className='new-icon ml-1' />
                ))}
              </span>
              {renderIf(item.tooltip)(
                <span className='sectioned-list__tooltip'>
                  <QuestionIconPopover placement='right'>
                    {item.tooltip}
                  </QuestionIconPopover>
                </span>
              )}
            </div>
          );
        })}
      </div>
    );
  });

  return (
    <div className='sectioned-list' aria-label={props.ariaLabel}>
      {sections}
    </div>
  );
}

export default SectionedList;
